import { businessKey } from 'queryKeys';

export const CONVERSION_PAGES = 'conversion-pages';

export const TAGS = 'tags';

const MUTATION_ADD_TAGS = 'addTags';
const MUTATION_EXPORT = 'export';

export const conversionPagesQuery = businessKey.query(CONVERSION_PAGES);

export const conversionPagesDetails = conversionPagesQuery.details();
export const conversionPagesModel = conversionPagesQuery.exact();

export const conversionPagesGrids = conversionPagesQuery.grids();
export const conversionPagesGrid = conversionPagesQuery.grid();

export const conversionPagesMutations = conversionPagesQuery.mutations();
export const conversionPagesUpdate = conversionPagesMutations.update();

export const tagsQuery = businessKey.query(TAGS);

export const tagsGrid = tagsQuery.grid();

export const tagsMutations = tagsQuery.mutations();
export const tagsCreate = tagsMutations.create();
export const tagsUpdate = tagsMutations.update();
export const tagsRemove = tagsMutations.delete();

export const addTags = conversionPagesMutations.mutate(MUTATION_ADD_TAGS);

export const exportPages = conversionPagesMutations.mutate(MUTATION_EXPORT);
